export default __webpack_public_path__ + "static/media/WalletConnect.d0813aa7.svg";